import React from 'react'

export default function AddField({ color }: { color: string }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M17.3333 10.6667V8H25.3333C26.8061 8 28 9.19391 28 10.6667V25.3333C28 26.8061 26.8061 28 25.3333 28H10.6667C9.19391 28 8 26.8061 8 25.3333V17.3333H10.6667V25.3333H25.3333V10.6667H17.3333ZM8 8V4H10.6667V8H14.6667V10.6667H10.6667V14.6667H8V10.6667H4V8H8Z" fill={color} />
    </svg>
  )
}